// extracted by mini-css-extract-plugin
export default {"container":"z90VV4Apuv8vfFmgGk_h","title":"iRl4H5zoXANgIdIvhN33","row":"ynyPG3FuDnSJKhKIRSvD","switch":"pON_vVhcVjjME2SkAryt","note":"fl9D2qtAnKWQGsSzGzvU"};